import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../lib/store';
import { pickRequestedFlags } from '../lib/util/flags/helpers';
import { FeatureFlags, RequestedFeatureFlags } from '../lib/util/flags/types';

/**
 * Reads feature flags off the store. They are fetched from the BFF once the
 * cookie session is valid and kept current over its SSE stream - see
 * `lib/store/feature-flags/epics`.
 *
 * A flag the BFF has not reported reads as disabled, which covers the window
 * before the first response and an unreachable BFF alike.
 */
const useFlags = (flags: FeatureFlags[]): RequestedFeatureFlags => {
  const stored = useSelector((state: RootState) => state.featureFlags.flags);
  const requestedKey = flags.join(',');

  return useMemo(() => pickRequestedFlags(stored, flags), [ stored, requestedKey ]);
};

export default useFlags;
